import { useQuery } from "@tanstack/react-query";
import { fetchAdminMe } from "@/services/adminAuth";

/**
 * The admin session check — GET /api/v1/admin-auth/me. A 401 (no admin cookie)
 * surfaces as a query error so `AdminProtectedRoute` can redirect to the admin
 * login. `retry: false` so a 401 doesn't thrash. Separate from the customer
 * `useAuthContext` — the admin realm is isolated.
 */
export const ADMIN_ME_KEY = ["admin-me"] as const;

export function useAdminMe() {
  return useQuery({
    queryKey: ADMIN_ME_KEY,
    queryFn: fetchAdminMe,
    retry: false,
    staleTime: 60_000,
  });
}
